import { Card, CardContent } from '@/components/ui/shadcn/card'

export default function NoAccess() {
  return (
    <div className="flex flex-1 items-center justify-center">
      <Card className="max-w-sm gap-3 py-4 text-center">
        <CardContent className="px-4">
          <h3 className="mb-2 text-lg font-semibold">No Access</h3>
          <p className="text-sm text-muted-foreground">
            Contact your administrator to request access, you currently have no
            access to any of the features in this application.
          </p>
        </CardContent>
      </Card>
    </div>
  )
}
